import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.Plumbing;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "Plumbing.Phaser.IntroductionScene.1",
            "Plumbing.Phaser.IntroductionScene.2",
            "Plumbing.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/PlumbingGame/scenes/GameIntro.ts